import React, { useEffect } from "react";
import { useState } from "react";
import Header from "./ExamComponents/Components/Header";
import ResultAnalysis from "./ExamComponents/Components/ResultAnalysis";
import SectionalAnalysis from "./ExamComponents/Components/SectionalAnalysis";
import CompetitiveAnalysis from "../ExamReview/ExamComponents/Components/CompetitiveAnalysis";
import GraphAnalysis from "../ExamReview/ExamComponents/Components/GraphAnalysis";
import { useDetails } from "./DetailsContext";
import SectionalView from "../../ExamPortal/ExamReview/ExamComponents/Components/SectionalView";
import QuestionView from "../../ExamPortal/ExamReview/ExamComponents/Components/QuestionView";
import GridView from "../../ExamPortal/ExamReview/ExamComponents/Components/GridView";

const MainResult = ({
  result,
  testSolutions,
  testSubjectsTopic,
  trackerId,
}) => {
  const { details } = useDetails();
  const [selected, setSelected] = useState("English");
  const [solutionActive, setSolutionActive] = useState(false);
  const [firstRadio, setFirstRadio] = useState(true);
  const [currentSubjectData, setCurrentSubjectData] = useState([]);


  console.log(result);
  console.log(testSolutions);
  console.log(testSubjectsTopic);
  // Filtering solutions subject wise
  useEffect(() => {
    const currentSubjectData1 = testSolutions?.filter((data) => {
      return data?.subject == selected;
    });
  
    setCurrentSubjectData(currentSubjectData1);
  }, [selected, testSolutions]);

 console.log(currentSubjectData,testSolutions,selected);
  // selecting current subject 
  useEffect(() => {
    setSelected(Object.keys(testSubjectsTopic)[0]);
  }, [testSubjectsTopic]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header
        solutionActive={solutionActive}
        setSolutionActive={setSolutionActive}
        firstRadio={firstRadio}
        setFirstRadio={setFirstRadio}
      />
      {!solutionActive && !details && (
        <>
          <div
            style={{
              marginTop: "2.5rem",
              paddingLeft: "3.5rem",
              fontSize: "1.875rem",
              lineHeight: "2.438rem",
              fontWeight: 700,
              marginBottom: "1.5rem",
              marginTop: "2.5rem",
              "font-family": "Montserrat",
              "font-size": "1.5rem",
            }}
          >
            Result Analysis
          </div>

          <ResultAnalysis result={result} />

          <SectionalAnalysis result={result} />

          <CompetitiveAnalysis result={result} />
          <GraphAnalysis />
        </>
      )}
      {details && (
        <>
          <div
            style={{ paddingLeft: "3.5rem", paddingRight: "3.5rem" }}
            className="headingdiv "
          >
            <div className="overalldiv">
              <div className="components" style={{ cursor: "pointer" }}>
                {result?.sectionalMarkings.map((temp) => {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelected(temp?.section)}
                      className={`${
                        temp?.section === selected ? "selected" : "type"
                      }`}
                    >
                      {temp?.section}
                    </div>
                  );
                })}
              </div>
            </div>
            <div>
              {testSubjectsTopic?.[selected]?.map((data, idx) => {
                return (
                  <SectionalView data={data} idx={idx} trackerId={trackerId} />
                );
              })}
            </div>
          </div>
        </>
      )}

      {solutionActive && !details && (
        <>
          <div
            style={{ paddingLeft: "3.5rem", paddingRight: "3.5rem" }}
            className="headingdiv "
          >
            <div className="overalldiv">
              <div className="components" style={{ cursor: "pointer" }}>
                {result?.sectionalMarkings.map((temp) => {
                  return (
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelected(temp?.section)}
                      className={`${
                        temp?.section === selected ? "selected" : "type"
                      }`}
                    >
                      {temp?.section}
                    </div>
                  );
                })}
              </div>
            </div>
            {firstRadio && (
              <div>
                {currentSubjectData?.map((data,idx) => {
                  return <QuestionView data={data} index={idx} trackerId={trackerId} />;
                })}
              </div>
            )}
            {console.log(firstRadio,currentSubjectData,"ram ram")}
            {!firstRadio && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                  padding: "auto",
                }}
              >
                
                <GridView testSolutions={currentSubjectData} trackerId={trackerId}  />
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MainResult;
